import React from "react";
import { useOutletContext } from "react-router";
import PropTypes from "prop-types";
import { useBillingAccounts, useCurrencyConversionMatrix } from "hooks";
import { LegacyTermSheetTable, LegacyTermSheetProvider } from "components/TermSheets";
import { MessagesNoResults } from "components/Messages";
import Card from "components/Card";

/**
 * LegacyTermSheetLayout
 * Container component that fetches data and wraps each termsheet with provider
 * @param {Boolean}     loading
 * @param {Array}       data - Array of termsheets
 */
const LegacyTermSheetLayout = ({ loading, data, ...props }) => {
  if (loading) return <Loader />;

  if (!data || data.length === 0) {
    return (
      <Card>
        <MessagesNoResults />
      </Card>
    );
  }

  const { selectedSquad } = useOutletContext();

  // Fetch complete currency conversion matrix (USD, CAD, EUR)
  const conversionMatrix = useCurrencyConversionMatrix();

  // Fetch billing accounts for the organization
  const { billingAccounts, loading: loadingBillingAccounts } = useBillingAccounts({
    organizationId: selectedSquad?.organization?.id,
  });

  return data?.map((termSheet) => (
    <LegacyTermSheetProvider
      key={termSheet.id}
      termSheet={termSheet}
      conversionMatrix={conversionMatrix}
      billingAccounts={billingAccounts}
      loadingBillingAccounts={loadingBillingAccounts}
      {...props}
    >
      <LegacyTermSheetTable loading={loading} />
    </LegacyTermSheetProvider>
  ));
};

const Loader = () => <LegacyTermSheetTable loading={true} />;

LegacyTermSheetLayout.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.array,
};

export default LegacyTermSheetLayout;
